import {OfficeContextAction, OfficeContextState, OfficeContextActionType} from './types';

// It's always a good thing to put the typing for the result of our reducer
// Some weird Typescript errors can happen if we don't define it
const reducer = (
  prevState: OfficeContextState,
  action: OfficeContextAction
): OfficeContextState => {
  switch (action.type) {
    case OfficeContextActionType.HIDE_PENDING_TASKS:
      return {
        ...prevState,
        pendingTasksVisible: action.pendingTasksVisible,
      };
    case OfficeContextActionType.TOGGLE_DRAWER:
      return {
        ...prevState,
        drawerOpened: action.drawerOpened,
      };
    case OfficeContextActionType.TOGGLE_NAVIGATION_DRAWER:
      return {
        ...prevState,
        sideNavigationDrawerCollapsed: action.sideNavigationDrawerCollapsed,
      };
    case OfficeContextActionType.SET_CURRENT_CAREGIVER_MODE_ENABLED:
      return {
        ...prevState,
        currentCaregiverModeEnabled: action.mode,
      };
    case OfficeContextActionType.SET_USER_FORM:
      return {
        ...prevState,
        userForm: {
          user: action.user,
          affiliation: action.affiliation,
          affiliationQuickAccess: action.affiliationQuickAccess,
        },
      };
    case OfficeContextActionType.SET_USER_FORM_LOAD_STATE:
      return {
        ...prevState,
        userFormLoadingState: action.state,
      };
    case OfficeContextActionType.CLEAR_USER_FORM:
      return {
        ...prevState,
        userForm: undefined,
      };
    case OfficeContextActionType.SET_USER_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        userFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_USER_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        userFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_USER_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        userFormDeleteButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_USER_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        userFormDeleteButtonState: undefined,
      };
    case OfficeContextActionType.SET_INFORMAL_CAREGIVER_INVITE_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        informalCaregiverInviteFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_INFORMAL_CAREGIVER_INVITE_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        informalCaregiverInviteFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_APPLICATION_FORM:
      return {
        ...prevState,
        applicationForm: action.application,
      };
    case OfficeContextActionType.CLEAR_APPLICATION_FORM:
      return {
        ...prevState,
        applicationForm: undefined,
      };
    case OfficeContextActionType.SET_INVITE:
      return {
        ...prevState,
        invite: action.invite,
      };
    case OfficeContextActionType.CLEAR_OCCURRENCE:
      return {
        ...prevState,
        occurrence: undefined,
      };
    case OfficeContextActionType.SET_OCCURRENCE:
      return {
        ...prevState,
        occurrence: action.occurrence,
      };
    case OfficeContextActionType.CLEAR_INVITE:
      return {
        ...prevState,
        invite: undefined,
      };
    case OfficeContextActionType.SET_ENTITY_FORM:
      return {
        ...prevState,
        entityForm: action.entity,
      };
    case OfficeContextActionType.SET_ENTITY_FORM_LOAD_STATE:
      return {
        ...prevState,
        entityFormLoadingState: action.state,
      };
    case OfficeContextActionType.CLEAR_ENTITY_FORM:
      return {
        ...prevState,
        entityForm: undefined,
      };
    case OfficeContextActionType.SET_APPLICATION_CATEGORY_FORM:
      return {
        ...prevState,
        applicationCategoryForm: action.applicationCategory,
      };
    case OfficeContextActionType.CLEAR_APPLICATION_CATEGORY_FORM:
      return {
        ...prevState,
        applicationCategoryForm: undefined,
      };
    case OfficeContextActionType.SET_APPLICATION_CATEGORY_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        applicationCategoryFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_APPLICATION_CATEGORY_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        applicationCategoryFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_APPLICATION_CATEGORY_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        applicationCategoryFormDeleteButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_APPLICATION_CATEGORY_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        applicationCategoryFormDeleteButtonState: undefined,
      };
    case OfficeContextActionType.SET_ENTITY_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        entityFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_ENTITY_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        entityFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_ENTITY_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        entityFormDeleteButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_ENTITY_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        entityFormDeleteButtonState: undefined,
      };
    case OfficeContextActionType.SET_PROFESSIONAL_CAREGIVER_INVITE_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        professionalCaregiverInviteFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_PROFESSIONAL_CAREGIVER_INVITE_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        professionalCaregiverInviteFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_ASSOCIATE_USER_CARD_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        associateUserCardFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_ASSOCIATE_USER_CARD_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        associateUserCardFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_ASSOCIATE_DEVICE_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        associateDeviceFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_ASSOCIATE_DEVICE_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        associateDeviceFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_USER_CARD_FORM:
      return {
        ...prevState,
        userCardForm: action.userCard,
      };
    case OfficeContextActionType.CLEAR_USER_CARD_FORM:
      return {
        ...prevState,
        userCardForm: undefined,
      };
    case OfficeContextActionType.SET_USER_CARD_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        userCardFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_USER_CARD_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        userCardFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_USER_CARD_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        userCardFormDeleteButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_USER_CARD_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        userCardFormDeleteButtonState: undefined,
      };

    case OfficeContextActionType.SET_DEVICE_FORM:
      return {
        ...prevState,
        deviceForm: action.device,
      };
    case OfficeContextActionType.CLEAR_DEVICE_FORM:
      return {
        ...prevState,
        deviceForm: undefined,
      };
    case OfficeContextActionType.SET_DEVICE_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        deviceFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_DEVICE_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        deviceFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_DEVICE_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        deviceFormDeleteButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_DEVICE_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        deviceFormDeleteButtonState: undefined,
      };
    case OfficeContextActionType.SET_PLAYLIST_FORM:
      return {
        ...prevState,
        playlistForm: action.playlist,
      };
    case OfficeContextActionType.CLEAR_PLAYLIST_FORM:
      return {
        ...prevState,
        playlistForm: undefined,
      };
    case OfficeContextActionType.SET_PLAYLIST_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        playlistFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_PLAYLIST_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        playlistFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_PLAYLIST_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        playlistFormDeleteButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_PLAYLIST_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        playlistFormDeleteButtonState: undefined,
      };
    case OfficeContextActionType.SET_PLAYLIST_ITEM_FORM:
      return {
        ...prevState,
        playlistItemForm: action.playlistItem,
      };
    case OfficeContextActionType.CLEAR_PLAYLIST_ITEM_FORM:
      return {
        ...prevState,
        playlistItemForm: undefined,
      };
    case OfficeContextActionType.SET_PLAYLIST_ITEM_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        playlistItemFormSubmitButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_PLAYLIST_ITEM_FORM_SUBMIT_BUTTON_STATE:
      return {
        ...prevState,
        playlistItemFormSubmitButtonState: undefined,
      };
    case OfficeContextActionType.SET_PLAYLIST_ITEM_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        playlistItemFormDeleteButtonState: action.state,
      };
    case OfficeContextActionType.CLEAR_PLAYLIST_ITEM_FORM_DELETE_BUTTON_STATE:
      return {
        ...prevState,
        playlistItemFormDeleteButtonState: undefined,
      };
    case OfficeContextActionType.UPDATE_VOXIMPLANT_STATE:
      return {
        ...prevState,
        voximplant: action.state,
      };
    case OfficeContextActionType.UPDATE_VIDEOCALL_STATE:
      return {
        ...prevState,
        videocall: action.state,
      };
    case OfficeContextActionType.SET_INCOMING_CALL:
      return {
        ...prevState,
        incomingCall: action.state,
      };
    case OfficeContextActionType.COLLAPSE_DRAWER:
      return {
        ...prevState,
        drawerCollapsed: action.drawerCollapsed,
        drawerCollapeDisabled: action.drawerCollapeDisabled,
      };
  }
};

export default reducer;
